import { IDialogAction } from './IDialogAction';
import { DialogState } from '../../dialog-feed/models/DialogState';

export const LIKE_REMOVED = 'LIKE_REMOVED';

export class LikeRemovedAction implements IDialogAction {
    public readonly type = LIKE_REMOVED;
    public constructor(public payload: any) { }
    public reducer(state: DialogState): DialogState {
        if (this.payload.ids.length > 2) {
            state.feed.messages.forEach(m => {
                m.comments.forEach(c => {
                    c.comments.forEach(ic => {
                        if (+ic.id !== this.payload.ids[2]) {
                            return;
                        }
                        if (state.feed.currentUser.externalId === this.payload.user.x) {
                            ic.liked = false;
                        }
                        if (ic.likes) {
                            let likeIndex = ic.likes.findIndex(l => l.externalId === this.payload.user.x);
                            if(likeIndex > -1)
                                ic.likes.splice(likeIndex, 1);
                        }
                    });
                });
            });
        }
        else if (this.payload.ids.length > 1) {
            state.feed.messages.forEach(m => {
                m.comments.forEach(c => {
                    if (+c.id !== this.payload.ids[1]) {
                        return;
                    }
                    if (state.feed.currentUser.externalId === this.payload.user.x) {
                        c.liked = false;
                    }
                    if (c.likes) {
                        let likeIndex = c.likes.findIndex(l => l.externalId === this.payload.user.x);
                        if(likeIndex > -1)
                            c.likes.splice(likeIndex, 1);
                    }
                });
            });
        }
        else if (this.payload.ids.length > 0) {
            state.feed.messages.forEach(m => {
                if (+m.id !== this.payload.ids[0]) {
                    return;
                }
                if (state.feed.currentUser.externalId === this.payload.user.x) {
                    m.liked = false;
                }
                if (m.likes) {
                    let likeIndex = m.likes.findIndex(l => l.externalId === this.payload.user.x);
                    if(likeIndex > -1)
                        m.likes.splice(likeIndex, 1);
                }
            });
        }
        return state;
    }
}

export const LikeRemovedActionTypeMapping = {
    [LIKE_REMOVED]: LikeRemovedAction
};